module.exports = "https://static.im-cdn.com/mjc/storefront/Sakra/static/media/InviteBanner.67a433ae.jpg";